// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"504":"d970fc80","628":"bf384f9f"}[chunkId] + ".chunk.js");